module.exports = __webpack_public_path__ + "static/img/product2.f26d854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product2.png
// module id = /n/2
// module chunks = 1